"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1324],{

/***/ 81324:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ContactDetails": function() { return /* reexport */ ContactDetails; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/chakra-ui-layout.esm.js
var chakra_ui_layout_esm = __webpack_require__(68527);
// EXTERNAL MODULE: ./node_modules/react-icons/gi/index.mjs
var gi = __webpack_require__(71054);
// EXTERNAL MODULE: ./node_modules/react-icons/lu/index.mjs
var lu = __webpack_require__(55451);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.mjs
var md = __webpack_require__(30080);
// EXTERNAL MODULE: ./node_modules/react-icons/pi/index.mjs
var pi = __webpack_require__(35282);
// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/@emotion/styled/dist/emotion-styled.browser.esm.js + 2 modules
var emotion_styled_browser_esm = __webpack_require__(16829);
;// CONCATENATED MODULE: ./src/components/organisms/ContactDetails/styles.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  background-color: white;\n  border: 1px solid #d8d8d8;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  height: 100%;\n  padding: 1.2rem 2rem;\n  min-width: 300px;\n  flex: 1 1 300px;\n  width: 0;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  flex-direction: row;\n  gap: 1rem;\n  margin-top: 1.5rem;\n  width: 100%;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  flex: 1 1 300px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  overflow-x: auto;\n  padding: 0 1rem 1rem 1rem;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}

var StyledBox = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject());
var StyledUSP = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject1());
var StyledBoxContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject2());
var ScrollableContainer = emotion_styled_browser_esm/* default.div */.Z.div(_templateObject3());

;// CONCATENATED MODULE: ./src/components/organisms/ContactDetails/ContactDetails.tsx
/* eslint-disable import/no-unresolved */ 







var supportHref = constants/* channelSlug */.m_ === "volte-uk" ? "https://thevolteuk.zendesk.com/hc/en-us" : "https://thevolte.zendesk.com/hc/en-au";
var items = [
    {
        href: "/dresses",
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(gi/* GiAmpleDress */.qJn, {
            size: 32
        }),
        title: "ENDLESS DRESS HIRE OPTIONS",
        description: "Explore a vast collection of designer dress rentals from renowned Australian and international designers."
    },
    {
        href: "/dashboard",
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(pi/* PiHandCoins */.TlY, {
            size: 32
        }),
        title: "SHARE AND EARN",
        description: "Earn by sharing and renting your wardrobe, with opt-in insurance keeping you protected."
    },
    {
        href: "/wear-the-dress-share-the-dress",
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(lu/* LuLeafyGreen */.lxZ, {
            size: 32
        }),
        title: "CIRCULAR FASHION",
        description: "Dress hire on the Volte champions sustainability and circular fashion."
    },
    {
        href: supportHref,
        icon: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(md/* MdOutlineContactSupport */.SB0, {
            size: 32
        }),
        title: "24/7 SUPPORT",
        description: "Around-the-Clock support for your dress rental enquiries. Click Live Chat or contact us via phone or email."
    }, 
];
var ContactDetails = function() {
    /*#__PURE__*/ return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ScrollableContainer, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledUSP, {
            children: items === null || items === void 0 ? void 0 : items.map(function(item, index) {
                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(StyledBoxContainer, {
                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* LinkBox */.fG, {
                        display: "flex",
                        h: "100%",
                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(StyledBox, {
                            children: [
                                item.icon,
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "h3",
                                    fontWeight: 600,
                                    fontSize: 16,
                                    lineHeight: "normal",
                                    children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* LinkOverlay */.AB, {
                                        fontWeight: "bold",
                                        href: item.href,
                                        children: item.title
                                    })
                                }),
                                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(chakra_ui_layout_esm/* Box */.xu, {
                                    as: "p",
                                    children: item.description
                                })
                            ]
                        })
                    })
                }, index);
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/organisms/ContactDetails/index.tsx



/***/ })

}]);